import { render } from "./GlobalPresenceOverlay.vue?vue&type=template&id=ee8ee698"
import script from "./GlobalPresenceOverlay.vue?vue&type=script&lang=js"
export * from "./GlobalPresenceOverlay.vue?vue&type=script&lang=js"

import "./GlobalPresenceOverlay.vue?vue&type=style&index=0&id=ee8ee698&lang=scss"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__